<template>
    <div
        :class="shouldIndent ? 'indent' : ''"
    >
        <span>
            {{ configOption.translated_name }}
            <DIcon
                v-if="!!configOption?.children && configOption.children.length"
                class="icon-size"
                :name="'arrow-down'"
            />
        </span>
        <a
            v-if="configOption.name === 'domain' && domainToolUrl != null"
            target="_blank"
            :href="domainToolUrl + configOption.value"
        > {{ configOption.value }} </a>
        <span v-if="configOption.display_value !== null && isLink(configOption.display_value)">
            <a
                target="_blank"
                :href="configOption.display_value"
            >
                {{ configOption.display_value }}
            </a>
        </span>
        <span
            v-else-if="hasNoDnssecSupport"
        >
            {{ __('customers.contracts.not_supported_by_tld') }}
        </span>
        <span
            v-else-if="configOption.display_value !== null"
            v-c-tooltip="configOption.value + ' - ' + __('customers.contracts.copy_id_to_clipboard')"
            class="cursor-pointer"
            @click="copyToClipboard(configOption.value)"
        >
            {{ configOption.display_value }}
            <DIcon
                name="information-slab-circle-outline"
                :size="18"
            />
        </span>
        <span v-else> {{ (value ?? '') + addResources }} </span>
        <DButton
            v-if="configOption.name === 'authcode' && isWaitingForDomainTransfer"
            color="danger"
            mini
            :label="__('customers.contracts.restart_transfer')"
            @click="$emit('restartTransfer')"
        />
    </div>
</template>

<script>

export default {
    name: 'ConfigOption',
    props: {
        configOption: {
            type: Object,
            default: () => {
                return {}
            }
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        hasProductConfig: {
            type: Boolean,
            default: false
        },
        domainToolUrl: {
            type: String,
            default: null
        },
        shouldIndent: {
            type: Boolean,
            default: false
        },
        isDomainTransfer: {
            type: Boolean,
            default: () => { return false }
        }
    },
    emits: ['restartTransfer'],
    data () {
        return {
            showInternalNoteModal: false,
            showInvoiceNoteModal: false,
            depth: 0,
            DNSSEC: 'dnssec'
        }
    },
    computed: {
        addResources () {
            return (this.getAdditionalResources() === null) ? '' : (' (+' + this.getAdditionalResources() + ' via add-ons)')
        },
        value () {
            if (this.configOption.name === 'fulfillment_package') {
                return this.getFulfillmentPackageName()
            }

            return this.configOption.value
        },
        hasNoDnssecSupport () {
            if (!this.hasProductConfig) {
                return !this.contract.supports_dns_sec && this.configOption.name === this.DNSSEC
            }

            return false
        },
        isWaitingForDomainTransfer () {
            return (this.contract.status === 'wait_for_fulfillment' || this.contract.status === 'wait_for_input') && this.isDomainTransfer
        }
    },
    methods: {
        copyToClipboard (value) {
            navigator.clipboard.writeText(value)
        },
        getFulfillmentPackageName () {
            let name = ''

            if (!this.configOption || !this.configOption.options) {
                return name
            }

            for (const optionValues of Object.values(this.configOption.options)) {
                if (Number(optionValues.value) === Number(this.configOption.value)) {
                    name = optionValues.value + ' - ' + optionValues.label
                }
            }

            return name
        },
        isLink (value) {
            try {
                return Boolean(new URL(value))
            } catch (e) {
                return false
            }
        },
        getAdditionalResources () {
            if (Object.keys(this.contract).length === 0) {
                return null
            }

            return this.contract.additionalResources[this.configOption.name] ?? null
        }
    }
}
</script>

<style scoped>
.indent {
    margin-left: 45px;
    margin-top: 5px;
}
.icon-size {
    font-size: 15px !important;
}
</style>
